import { AccordionItem as FluentAccordionItem } from "@fluentui/web-components";
/**
 * AccordionItem
 * @summary An Accordion Item Custom HTML Element that can be expanded or collapsed, with customizable size and marker position.
 *
 * @example
 * ```html
 * <fabric-accordion-item size="large" marker-position="end" block>
 *   <span slot="heading">Section 1</span>
 *   Lorem ipsum dolor sit amet...
 * </fabric-accordion-item>
 * ```
 *
 * @attr {AccordionItemSize | undefined} size - The size of the accordion item header which can be small, medium, large, or extra-large.
 * @attr {AccordionItemMarkerPosition | undefined} marker-position - The position of the expand/collapse icon which can be at the start or end of the accordion.
 * @attr {number | undefined} heading-level - The level of the heading.
 * @attr {boolean | undefined} expanded - Whether the accordion item is expanded.
 * @attr {boolean | undefined} disabled - Whether the accordion item is disabled.
 * @attr {boolean | undefined} block - Sets the width of the focus state to fill the container.
 *
 * @prop {AccordionItemSize | undefined} size - The size of the accordion item header which can be small, medium, large, or extra-large.
 * @prop {AccordionItemMarkerPosition | undefined} markerPosition - The position of the expand/collapse icon which can be at the start or end of the accordion.
 * @prop {number | undefined} headingLevel - The level of the heading.
 * @prop {boolean | undefined} expanded - Whether the accordion item is expanded.
 * @prop {boolean | undefined} disabled - Whether the accordion item is disabled.
 * @prop {boolean | undefined} block - Sets the width of the focus state to fill the container.
 *
 * @slot heading - The content for the accordion item's heading.
 * @slot - The default slot for the accordion item's content.
 * @slot marker-expanded - The content for the expanded state marker, defaults to a chevron down icon.
 * @slot marker-collapsed - The content for the collapsed state marker, defaults to a chevron right icon.
 *
 * @csspart heading - The accordion item's heading container.
 * @csspart button - The button element used to expand or collapse the item.
 * @csspart content - The container for the accordion item's content.
 *
 * @extends FluentAccordionItem
 * @tagname fabric-accordion-item
 * @public
 */
export class AccordionItem extends FluentAccordionItem {
}
//# sourceMappingURL=accordion-item.js.map